import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import {
  CostRate,
  CostRateApi,
  CostRateManagerBaseProps,
  CostRateSourceType,
  DeleteCostRateProps,
  UpdateCostRateProps,
} from 'api/cost-rates';

export type CostRateForResourceKey = ['cost-rate', CostRateSourceType, number];

export const getCostRateForResourceKey = ({
  sourceId,
  sourceType,
}: CostRateManagerBaseProps): CostRateForResourceKey => [
  'cost-rate',
  sourceType,
  sourceId,
];

export const useCostRateForResourceQuery = (
  payload: CostRateManagerBaseProps,
  queryOptions: UseQueryOptions<
    CostRate,
    unknown,
    CostRate,
    CostRateForResourceKey
  > = {},
): UseQueryResult<CostRate> =>
  useQuery(
    getCostRateForResourceKey(payload),
    () => CostRateApi.getCostRate(payload),
    {
      ...queryOptions,
      cacheTime: 0,
    },
  );

export const useCostRateForResourceMutation = (
  options: UseMutationOptions<CostRate, unknown, UpdateCostRateProps> = {},
): UseMutationResult<CostRate, unknown, UpdateCostRateProps> => {
  const queryClient = useQueryClient();

  return useMutation((data) => CostRateApi.updateCostRate(data), {
    ...options,

    onSuccess: async (data) => {
      queryClient.invalidateQueries(
        getCostRateForResourceKey({
          sourceId: data.sourceId,
          sourceType: data.sourceType,
        }),
      );
    },
  });
};

export const useCostRateDeleteMutation = (
  options: UseMutationOptions<void, unknown, DeleteCostRateProps> = {},
): UseMutationResult<void, unknown, DeleteCostRateProps> => {
  const queryClient = useQueryClient();

  return useMutation((data) => CostRateApi.deleteCostRate(data), {
    ...options,

    onSuccess: async (_, data) => {
      queryClient.invalidateQueries(
        getCostRateForResourceKey({
          sourceId: data.sourceId,
          sourceType: data.sourceType,
        }),
      );
    },
  });
};
